import { render } from "./CBreadcrumb.vue?vue&type=template&id=d1f5cfb2"
import script from "./CBreadcrumb.vue?vue&type=script&lang=js"
export * from "./CBreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__